import { render, staticRenderFns } from "./CanvasUserIsTyping.vue?vue&type=template&id=839a1294&scoped=true&"
import script from "./CanvasUserIsTyping.vue?vue&type=script&lang=js&"
export * from "./CanvasUserIsTyping.vue?vue&type=script&lang=js&"
import style0 from "./CanvasUserIsTyping.vue?vue&type=style&index=0&id=839a1294&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839a1294",
  null
  
)

export default component.exports